import { RouteObject } from "react-router-dom"
import ApplicationTemplate from "common/layouts/application";
import SettingConditionEdit from "./pages/SettingConditionEdit";
import GroupMemberIndex from "./pages/GroupMemberIndex";
import SettingIndex from "./pages/SettingIndex";
import SignalLayout from "./pages/SignalLayout";
import TermsOfServiceAgree from "./pages/TermsOfServiceAgree";
import UserTeamIndex from "./pages/UserTeamIndex";
import { ProvideAuth } from "hooks/useAuth";
import AuthedUrqlProvider from "providers/AuthedUrqlProvider";
import { Protected } from "utils/auth/protect";

const SignalRoutes: RouteObject[] = [
  {
    path: "signal",
    element: (
      <ProvideAuth>
        <AuthedUrqlProvider>
          <Protected>
            <ApplicationTemplate>
              <SignalLayout />
            </ApplicationTemplate>
          </Protected>
        </AuthedUrqlProvider>
      </ProvideAuth>
    ),
    children: [
      { index: true, element: <SettingIndex /> },
      { path: "condition_edit", element: <SettingConditionEdit /> },
      { path: "group_members", element: <GroupMemberIndex /> },
      { path: "user_teams", element: <UserTeamIndex /> },
      { path: "terms_of_service", element: <TermsOfServiceAgree /> },
    ],
  },
]

export default SignalRoutes;
